import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import Theme from 'components/template/Theme'
import Layout from 'components/layout'
import history from './history'
import './locales'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { Spinner } from 'components/ui'
import { dateLocales, updateTranslations } from 'locales'
import { getLanguage, getTranslation } from 'services/LanguageService'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import dayjs from 'dayjs'
import i18n from 'i18next'

const readPersistedLocale = () => {
    try {
        const raw = localStorage.getItem(PERSIST_STORE_NAME)
        if (!raw) return null
        const parsed = JSON.parse(raw)
        const localeRaw = parsed?.locale
        if (!localeRaw) return null
        const localeObj = typeof localeRaw === 'string' ? JSON.parse(localeRaw) : localeRaw
        return localeObj?.currentLang || null
    } catch {
        return null
    }
}

function App() {
    const [bootLoading, setBootLoading] = useState(true)

    useEffect(() => {
        const loadDefaultI18n = async () => {
            try {
                const persistedLocale = (readPersistedLocale() || 'tr').toLowerCase().split('-')[0]
                const response = await getLanguage()
                const list = response?.data?.data || []
                const matchLanguage =
                    list.find(
                        (lang) =>
                            lang.isActive &&
                            String(lang.code || '').toLowerCase().startsWith(persistedLocale)
                    ) ||
                    list.find(
                        (lang) =>
                            lang.isActive && String(lang.code || '').toLowerCase().startsWith('tr')
                    )
                if (matchLanguage) {
                    const targetLocale = String(matchLanguage.code || '')
                        .toLowerCase()
                        .split('-')[0]
                    const trans = await getTranslation({ code: matchLanguage.code })
                    const items = trans?.data?.data || []
                    if (Array.isArray(items) && items.length) {
                        await updateTranslations(targetLocale, items)
                    }
                    try {
                        if (dateLocales[targetLocale]) {
                            await dateLocales[targetLocale]()
                            dayjs.locale(targetLocale)
                        }
                    } catch {}
                    i18n.changeLanguage(targetLocale)
                }
            } catch (e) {
                // Swallow errors and continue
            } finally {
                setBootLoading(false)
            }
        }
        loadDefaultI18n()
    }, [])

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter history={history}>
                    <GoogleOAuthProvider clientId={"603599973081-55eu7b6fl0t6k258i2mpietdgvbb2jmc.apps.googleusercontent.com"}>
                        {bootLoading ? (
                            <div className="flex h-screen w-full justify-center items-center flex-col">
                                <Spinner size="3.25rem" />
                            </div>
                        ) : (
                            <Theme>
                                <Layout />
                            </Theme>
                        )}
                    </GoogleOAuthProvider>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}

export default App
